import "core-js/modules/es.array.sort.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.sort.js";
import React, { useState, useEffect } from 'react';
import { useStaticQuery, Link } from 'gatsby';
import Helmet from 'react-helmet';
import TopNavComponent from '@accrosoft-ltd/accropress-theme-inspiration/src/components/topNavComponent';
import GrabMenuImage from '@accrosoft-ltd/accropress-theme-inspiration/src/components/grabMenuImage';
import HeaderMenuBarNested from '@accrosoft-ltd/accropress-websites-components/dist/esm/HeaderMenuBarNested';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Header = function Header(props) {
  var _useState = useState(false),
      isMobile = _useState[0],
      setIsMobile = _useState[1];

  var _useState2 = useState(false),
      scrolled = _useState2[0],
      setScrolled = _useState2[1];

  useEffect(function () {
    var handleScroll = function handleScroll(event) {
      if (window && window.scrollY === 0) {
        setScrolled(false);
      } else if (window && window.scrollY > 0) {
        setScrolled(true);
      }
    };

    if (window) {
      if (window.innerWidth <= 1190) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }

      window.addEventListener('resize', function () {
        if (window.innerWidth <= 1190) {
          setIsMobile(true);
        } else {
          setIsMobile(false);
        }
      });
      window.addEventListener('scroll', handleScroll);
    }
  }, []);

  var _useState3 = useState(false),
      toggleMobileNav = _useState3[0],
      setToggleMobileNav = _useState3[1];

  var _useState4 = useState([]),
      websiteNavData = _useState4[0],
      setWebsiteNavData = _useState4[1];

  var _useState5 = useState(true),
      websiteNavLoading = _useState5[0],
      setWebsiteNavLoading = _useState5[1];

  var accropressWebsiteNavigation = useStaticQuery("3654090883");

  var returnSortedNavigation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(websiteNavJSON, fromGQL) {
      var GetSortOrder, dynamicSort, procesItem, processArray, websiteNavItems, _websiteNavItems;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!websiteNavLoading) {
                _context3.next = 18;
                break;
              }

              GetSortOrder = function GetSortOrder(prop) {
                return function (a, b) {
                  if (a[prop] > b[prop]) {
                    return 1;
                  } else if (a[prop] < b[prop]) {
                    return -1;
                  }

                  return 0;
                };
              };

              dynamicSort = function dynamicSort(property) {
                var sortOrder = 1;

                if (property[0] === "-") {
                  sortOrder = -1;
                  property = property.substr(1);
                }

                return function (a, b) {
                  /* next line works with strings and numbers,
                   * and you may want to customize it to your needs
                   */
                  var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
                  return result * sortOrder;
                };
              };

              procesItem = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item, newArrayOrder) {
                  var newChildrenOrder;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!item.children) {
                            _context.next = 8;
                            break;
                          }

                          _context.next = 3;
                          return item.children.sort(dynamicSort("order"));

                        case 3:
                          newChildrenOrder = _context.sent;
                          item.children = newChildrenOrder;
                          newArrayOrder.push(item);
                          _context.next = 9;
                          break;

                        case 8:
                          newArrayOrder.push(item);

                        case 9:
                          return _context.abrupt("return", item);

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function procesItem(_x3, _x4) {
                  return _ref2.apply(this, arguments);
                };
              }();

              processArray = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(array) {
                  var newArrayOrder, _iterator, _step, item;

                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          newArrayOrder = [];
                          _iterator = _createForOfIteratorHelperLoose(array);

                        case 2:
                          if ((_step = _iterator()).done) {
                            _context2.next = 8;
                            break;
                          }

                          item = _step.value;
                          _context2.next = 6;
                          return procesItem(item, newArrayOrder);

                        case 6:
                          _context2.next = 2;
                          break;

                        case 8:
                          _context2.next = 10;
                          return newArrayOrder.sort(dynamicSort("order"));

                        case 10:
                          newArrayOrder = _context2.sent;
                          return _context2.abrupt("return", newArrayOrder);

                        case 12:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function processArray(_x5) {
                  return _ref3.apply(this, arguments);
                };
              }();

              if (!fromGQL) {
                _context3.next = 13;
                break;
              }

              _context3.next = 8;
              return processArray(websiteNavJSON.allAccroPress.nodes[0].menu);

            case 8:
              websiteNavItems = _context3.sent;

              if (websiteNavItems) {
                setWebsiteNavData(websiteNavItems);
              } else {
                setWebsiteNavData(websiteNavJSON.allAccroPress.nodes[0].menu);
              }

              setWebsiteNavLoading(false);
              _context3.next = 18;
              break;

            case 13:
              _context3.next = 15;
              return processArray(websiteNavJSON.menu);

            case 15:
              _websiteNavItems = _context3.sent;

              if (_websiteNavItems) {
                setWebsiteNavData(_websiteNavItems);
              } else {
                setWebsiteNavData(websiteNavJSON.menu);
              }

              setWebsiteNavLoading(false);

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function returnSortedNavigation(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    returnSortedNavigation(props.navResultData || accropressWebsiteNavigation, props.navResultData ? false : true);
  }, [websiteNavLoading]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Helmet, {
      children: [/*#__PURE__*/_jsx("link", {
        rel: "shortcut icon",
        href: "/favicon.ico"
      }), /*#__PURE__*/_jsx("title", {
        children: props.gatsbyConfigSiteMetaData.title
      })]
    }), /*#__PURE__*/_jsxs("header", {
      className: 'header ' + (scrolled === true ? 'scrolled' : ''),
      id: "header",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "container",
        children: [/*#__PURE__*/_jsx("div", {
          className: "logo",
          children: /*#__PURE__*/_jsx(Link, {
            to: "/",
            children: /*#__PURE__*/_jsx("img", {
              src: props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload.length > 0 && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0] && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0].children ? props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0].children.find(function (o) {
                return o.id === 'logo-image';
              }).value || props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0].children.find(function (o) {
                return o.id === 'logo-image';
              }).default : props.gatsbyConfigPluginsAPOptions.siteSettings.theme.themeSettingsDefinition[0].children.find(function (o) {
                return o.id === 'logo-image';
              }).default,
              alt: props.gatsbyConfigSiteMetaData.title
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "website-nav-wrap",
          children: [/*#__PURE__*/_jsx("div", {
            className: "website-nav-inner-wrap website-nav-inner-wrap-top",
            children: /*#__PURE__*/_jsx(TopNavComponent, {})
          }), !websiteNavLoading ? /*#__PURE__*/_jsxs("div", {
            className: "website-nav-inner-wrap",
            children: [/*#__PURE__*/_jsx("div", {
              className: "menuToggler",
              onClick: function onClick() {
                return setToggleMobileNav(!toggleMobileNav);
              },
              children: !toggleMobileNav ? /*#__PURE__*/_jsx("span", {
                className: "fas fa-bars"
              }) : /*#__PURE__*/_jsx("span", {
                className: "fas fa-times"
              })
            }), /*#__PURE__*/_jsxs("ul", {
              className: toggleMobileNav ? 'toggledMobile' : 'notToggled',
              children: [/*#__PURE__*/_jsx(HeaderMenuBarNested, {
                websiteNavData: websiteNavData,
                isMobile: isMobile
              }), isMobile && /*#__PURE__*/_jsx("div", {
                className: "website-nav-inner-wrap website-nav-inner-wrap-top",
                children: /*#__PURE__*/_jsx(TopNavComponent, {})
              })]
            })]
          }) : /*#__PURE__*/_jsx("div", {
            className: "website-nav-inner-wrap website-nav-inner-wrap-loading"
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "header-brush-stroke"
      })]
    })]
  });
};

export default Header;